import theme from '@theme-ui/preset-tailwind';

export const radii = {
  ...(theme.radii && theme.radii),
};
